import {configureStore} from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import {apiSlice} from "./slices/apiSlice";
import vehicleReducer from "./slices/vehicleSlice";
import lineReducer from "./slices/lineSlice";
import driverReducer from "./slices/driverSlice";
import mapSlice from "./slices/mapSlice";
import mapLayer from "./slices/mapLayerSlice";
import notificationsReducer from "./slices/notificationSlice";
import liveItemsReducer from "./slices/liveItems";
import mapSettingsReducer from "./slices/mapSettingSlice";
import positionReducer from "./slices/positionSlice";

const stores = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        auth: authReducer,
        vehicle: vehicleReducer,
        line: lineReducer,
        driver: driverReducer,
        map: mapSlice,
        mapLayer: mapLayer,
        notifications: notificationsReducer,
        liveItems: liveItemsReducer,
        mapSettings: mapSettingsReducer,
        positions: positionReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(apiSlice.middleware),
    devTools: true,
});

export default stores;
